import { useMemo } from 'react';
import GoogleLocationsList, { useGoogleLocationsFilter } from '@features/GoogleLocationsList';
import { objectIsEmpty } from '@helpers/objectIsEmpty';
import GoogleLocationCard from './GoogleLocationCard';

const GoogleLocationPicker = ({ locations, selectedLocation, setLocation }) => {
    const selected = useMemo(() => (objectIsEmpty(selectedLocation) ? [] : [selectedLocation]), [selectedLocation]);
    const filter = useGoogleLocationsFilter(locations, { selected });

    return (
        <GoogleLocationsList
            filter={filter}
            renderLocation={item => (
                <GoogleLocationCard location={item} selectedLocation={selectedLocation} setLocation={setLocation} />
            )}
        />
    );
};

export default GoogleLocationPicker;
